// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("qwc2-icons.woff?bd00e53d79ac9a24b85f1ac5633a45e9", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
	font-family: "qwc2-icons";
	src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff");
}

.icon {
	line-height: 1;
}

.icon:before {
	font-family: qwc2-icons !important;
	font-style: normal;
	font-weight: normal !important;
	vertical-align: top;
}

.icon-zoomout:before {
	content: "\\f101";
}
.icon-zoomin:before {
	content: "\\f102";
}
.icon-zoom:before {
	content: "\\f103";
}
.icon-wedge:before {
	content: "\\f104";
}
.icon-warning:before {
	content: "\\f105";
}
.icon-view:before {
	content: "\\f106";
}
.icon-up-down-arrow:before {
	content: "\\f107";
}
.icon-unpin:before {
	content: "\\f108";
}
.icon-unminimize:before {
	content: "\\f109";
}
.icon-unmaximize:before {
	content: "\\f10a";
}
.icon-undock:before {
	content: "\\f10b";
}
.icon-undock_top:before {
	content: "\\f10c";
}
.icon-undock_right:before {
	content: "\\f10d";
}
.icon-undock_left:before {
	content: "\\f10e";
}
.icon-undock_bottom:before {
	content: "\\f10f";
}
.icon-unchecked:before {
	content: "\\f110";
}
.icon-tristate:before {
	content: "\\f111";
}
.icon-triangle-up:before {
	content: "\\f112";
}
.icon-triangle-right:before {
	content: "\\f113";
}
.icon-triangle-left:before {
	content: "\\f114";
}
.icon-triangle-down:before {
	content: "\\f115";
}
.icon-tree:before {
	content: "\\f116";
}
.icon-tree_plus:before {
	content: "\\f117";
}
.icon-tree_minus:before {
	content: "\\f118";
}
.icon-trash:before {
	content: "\\f119";
}
.icon-trash_checked:before {
	content: "\\f11a";
}
.icon-transparency:before {
	content: "\\f11b";
}
.icon-transformtool:before {
	content: "\\f11c";
}
.icon-tools:before {
	content: "\\f11d";
}
.icon-today:before {
	content: "\\f11e";
}
.icon-tilt-up:before {
	content: "\\f11f";
}
.icon-tilt-right:before {
	content: "\\f120";
}
.icon-tilt-left:before {
	content: "\\f121";
}
.icon-tilt-down:before {
	content: "\\f122";
}
.icon-themes:before {
	content: "\\f123";
}
.icon-text:before {
	content: "\\f124";
}
.icon-sync:before {
	content: "\\f125";
}
.icon-sunexp:before {
	content: "\\f126";
}
.icon-star:before {
	content: "\\f127";
}
.icon-square:before {
	content: "\\f128";
}
.icon-sphere:before {
	content: "\\f129";
}
.icon-snap_vertex:before {
	content: "\\f12a";
}
.icon-snap_perpendicular:before {
	content: "\\f12b";
}
.icon-snap_intersection:before {
	content: "\\f12c";
}
.icon-snap_edge:before {
	content: "\\f12d";
}
.icon-snap_3d:before {
	content: "\\f12e";
}
.icon-share:before {
	content: "\\f12f";
}
.icon-selectbox:before {
	content: "\\f130";
}
.icon-search:before {
	content: "\\f131";
}
.icon-screenshot:before {
	content: "\\f132";
}
.icon-scale:before {
	content: "\\f133";
}
.icon-save:before {
	content: "\\f134";
}
.icon-routing:before {
	content: "\\f135";
}
.icon-routing-walking:before {
	content: "\\f136";
}
.icon-routing-truck:before {
	content: "\\f137";
}
.icon-routing-tram:before {
	content: "\\f138";
}
.icon-routing-train:before {
	content: "\\f139";
}
.icon-routing-ship:before {
	content: "\\f13a";
}
.icon-routing-car:before {
	content: "\\f13b";
}
.icon-routing-cablecar:before {
	content: "\\f13c";
}
.icon-routing-bus:before {
	content: "\\f13d";
}
.icon-routing-bicycle:before {
	content: "\\f13e";
}
.icon-report:before {
	content: "\\f13f";
}
.icon-remove:before {
	content: "\\f140";
}
.icon-refresh:before {
	content: "\\f141";
}
.icon-rect:before {
	content: "\\f142";
}
.icon-rasterexport:before {
	content: "\\f143";
}
.icon-radio_unchecked:before {
	content: "\\f144";
}
.icon-radio_tristate:before {
	content: "\\f145";
}
.icon-radio_checked:before {
	content: "\\f146";
}
.icon-pyramid:before {
	content: "\\f147";
}
.icon-public:before {
	content: "\\f148";
}
.icon-print:before {
	content: "\\f149";
}
.icon-polygon:before {
	content: "\\f14a";
}
.icon-point:before {
	content: "\\f14b";
}
.icon-point_buffer:before {
	content: "\\f14c";
}
.icon-plus:before {
	content: "\\f14d";
}
.icon-plot_info:before {
	content: "\\f14e";
}
.icon-pin:before {
	content: "\\f14f";
}
.icon-pick:before {
	content: "\\f150";
}
.icon-pick_region:before {
	content: "\\f151";
}
.icon-pick_point:before {
	content: "\\f152";
}
.icon-person:before {
	content: "\\f153";
}
.icon-pen:before {
	content: "\\f154";
}
.icon-pdf:before {
	content: "\\f155";
}
.icon-paint:before {
	content: "\\f156";
}
.icon-open:before {
	content: "\\f157";
}
.icon-open_link:before {
	content: "\\f158";
}
.icon-ok:before {
	content: "\\f159";
}
.icon-oblique:before {
	content: "\\f15a";
}
.icon-numericinput:before {
	content: "\\f15b";
}
.icon-nodetool:before {
	content: "\\f15c";
}
.icon-new:before {
	content: "\\f15d";
}
.icon-nav-start:before {
	content: "\\f15e";
}
.icon-nav-right:before {
	content: "\\f15f";
}
.icon-nav-left:before {
	content: "\\f160";
}
.icon-nav-end:before {
	content: "\\f161";
}
.icon-move:before {
	content: "\\f162";
}
.icon-minus:before {
	content: "\\f163";
}
.icon-minus-sign:before {
	content: "\\f164";
}
.icon-minimize:before {
	content: "\\f165";
}
.icon-middle_v:before {
	content: "\\f166";
}
.icon-middle_h:before {
	content: "\\f167";
}
.icon-menu-hamburger:before {
	content: "\\f168";
}
.icon-measureobj:before {
	content: "\\f169";
}
.icon-measure:before {
	content: "\\f16a";
}
.icon-measure_polygon:before {
	content: "\\f16b";
}
.icon-measure_line:before {
	content: "\\f16c";
}
.icon-maximize:before {
	content: "\\f16d";
}
.icon-map3d:before {
	content: "\\f16e";
}
.icon-logout:before {
	content: "\\f16f";
}
.icon-login:before {
	content: "\\f170";
}
.icon-lock:before {
	content: "\\f171";
}
.icon-list-alt:before {
	content: "\\f172";
}
.icon-link:before {
	content: "\\f173";
}
.icon-line:before {
	content: "\\f174";
}
.icon-line_buffer:before {
	content: "\\f175";
}
.icon-light:before {
	content: "\\f176";
}
.icon-layers:before {
	content: "\\f177";
}
.icon-label:before {
	content: "\\f178";
}
.icon-info:before {
	content: "\\f179";
}
.icon-info-sign:before {
	content: "\\f17a";
}
.icon-import:before {
	content: "\\f17b";
}
.icon-identify_region:before {
	content: "\\f17c";
}
.icon-identify_radius:before {
	content: "\\f17d";
}
.icon-home:before {
	content: "\\f17e";
}
.icon-group:before {
	content: "\\f17f";
}
.icon-freehand:before {
	content: "\\f180";
}
.icon-folder-open:before {
	content: "\\f181";
}
.icon-filter:before {
	content: "\\f182";
}
.icon-fill:before {
	content: "\\f183";
}
.icon-featureform:before {
	content: "\\f184";
}
.icon-eye:before {
	content: "\\f185";
}
.icon-eye-slash:before {
	content: "\\f186";
}
.icon-export:before {
	content: "\\f187";
}
.icon-expand:before {
	content: "\\f188";
}
.icon-epsilon:before {
	content: "\\f189";
}
.icon-embed:before {
	content: "\\f18a";
}
.icon-ellipse:before {
	content: "\\f18b";
}
.icon-editing:before {
	content: "\\f18c";
}
.icon-edited:before {
	content: "\\f18d";
}
.icon-editdraw:before {
	content: "\\f18e";
}
.icon-draw:before {
	content: "\\f18f";
}
.icon-drag:before {
	content: "\\f190";
}
.icon-dock:before {
	content: "\\f191";
}
.icon-dock_top:before {
	content: "\\f192";
}
.icon-dock_right:before {
	content: "\\f193";
}
.icon-dock_left:before {
	content: "\\f194";
}
.icon-dock_bottom:before {
	content: "\\f195";
}
.icon-detach:before {
	content: "\\f196";
}
.icon-dataimport:before {
	content: "\\f197";
}
.icon-cylinder:before {
	content: "\\f198";
}
.icon-cyclomedia:before {
	content: "\\f199";
}
.icon-cuboid:before {
	content: "\\f19a";
}
.icon-copy:before {
	content: "\\f19b";
}
.icon-confirm:before {
	content: "\\f19c";
}
.icon-cone:before {
	content: "\\f19d";
}
.icon-compare:before {
	content: "\\f19e";
}
.icon-collapse:before {
	content: "\\f19f";
}
.icon-cog:before {
	content: "\\f1a0";
}
.icon-clone:before {
	content: "\\f1a1";
}
.icon-clock:before {
	content: "\\f1a2";
}
.icon-clear:before {
	content: "\\f1a3";
}
.icon-circle:before {
	content: "\\f1a4";
}
.icon-circle_full:before {
	content: "\\f1a5";
}
.icon-chevron-up:before {
	content: "\\f1a6";
}
.icon-chevron-right:before {
	content: "\\f1a7";
}
.icon-chevron-left:before {
	content: "\\f1a8";
}
.icon-chevron-down:before {
	content: "\\f1a9";
}
.icon-checked:before {
	content: "\\f1aa";
}
.icon-catalog:before {
	content: "\\f1ab";
}
.icon-camera:before {
	content: "\\f1ac";
}
.icon-buffer:before {
	content: "\\f1ad";
}
.icon-box:before {
	content: "\\f1ae";
}
.icon-bookmark:before {
	content: "\\f1af";
}
.icon-bglayer:before {
	content: "\\f1b0";
}
.icon-below:before {
	content: "\\f1b1";
}
.icon-before:before {
	content: "\\f1b2";
}
.icon-arrow-up:before {
	content: "\\f1b3";
}
.icon-arrow-down:before {
	content: "\\f1b4";
}
.icon-after:before {
	content: "\\f1b5";
}
.icon-above:before {
	content: "\\f1b6";
}
.icon-above_zero:before {
	content: "\\f1b7";
}
.icon-above_terr:before {
	content: "\\f1b8";
}
.icon-3d2d:before {
	content: "\\f1b9";
}
.icon-3d:before {
	content: "\\f1ba";
}
.icon-2d:before {
	content: "\\f1bb";
}
`, "",{"version":3,"sources":["webpack://./icons/build/qwc2-icons.css"],"names":[],"mappings":"AAAA;CACC,yBAAyB;CACzB,2DAA2E;AAC5E;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kCAAkC;CAClC,kBAAkB;CAClB,8BAA8B;CAC9B,mBAAmB;AACpB;;AAEA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB","sourcesContent":["@font-face {\n\tfont-family: \"qwc2-icons\";\n\tsrc: url(\"qwc2-icons.woff?bd00e53d79ac9a24b85f1ac5633a45e9\") format(\"woff\");\n}\n\n.icon {\n\tline-height: 1;\n}\n\n.icon:before {\n\tfont-family: qwc2-icons !important;\n\tfont-style: normal;\n\tfont-weight: normal !important;\n\tvertical-align: top;\n}\n\n.icon-zoomout:before {\n\tcontent: \"\\f101\";\n}\n.icon-zoomin:before {\n\tcontent: \"\\f102\";\n}\n.icon-zoom:before {\n\tcontent: \"\\f103\";\n}\n.icon-wedge:before {\n\tcontent: \"\\f104\";\n}\n.icon-warning:before {\n\tcontent: \"\\f105\";\n}\n.icon-view:before {\n\tcontent: \"\\f106\";\n}\n.icon-up-down-arrow:before {\n\tcontent: \"\\f107\";\n}\n.icon-unpin:before {\n\tcontent: \"\\f108\";\n}\n.icon-unminimize:before {\n\tcontent: \"\\f109\";\n}\n.icon-unmaximize:before {\n\tcontent: \"\\f10a\";\n}\n.icon-undock:before {\n\tcontent: \"\\f10b\";\n}\n.icon-undock_top:before {\n\tcontent: \"\\f10c\";\n}\n.icon-undock_right:before {\n\tcontent: \"\\f10d\";\n}\n.icon-undock_left:before {\n\tcontent: \"\\f10e\";\n}\n.icon-undock_bottom:before {\n\tcontent: \"\\f10f\";\n}\n.icon-unchecked:before {\n\tcontent: \"\\f110\";\n}\n.icon-tristate:before {\n\tcontent: \"\\f111\";\n}\n.icon-triangle-up:before {\n\tcontent: \"\\f112\";\n}\n.icon-triangle-right:before {\n\tcontent: \"\\f113\";\n}\n.icon-triangle-left:before {\n\tcontent: \"\\f114\";\n}\n.icon-triangle-down:before {\n\tcontent: \"\\f115\";\n}\n.icon-tree:before {\n\tcontent: \"\\f116\";\n}\n.icon-tree_plus:before {\n\tcontent: \"\\f117\";\n}\n.icon-tree_minus:before {\n\tcontent: \"\\f118\";\n}\n.icon-trash:before {\n\tcontent: \"\\f119\";\n}\n.icon-trash_checked:before {\n\tcontent: \"\\f11a\";\n}\n.icon-transparency:before {\n\tcontent: \"\\f11b\";\n}\n.icon-transformtool:before {\n\tcontent: \"\\f11c\";\n}\n.icon-tools:before {\n\tcontent: \"\\f11d\";\n}\n.icon-today:before {\n\tcontent: \"\\f11e\";\n}\n.icon-tilt-up:before {\n\tcontent: \"\\f11f\";\n}\n.icon-tilt-right:before {\n\tcontent: \"\\f120\";\n}\n.icon-tilt-left:before {\n\tcontent: \"\\f121\";\n}\n.icon-tilt-down:before {\n\tcontent: \"\\f122\";\n}\n.icon-themes:before {\n\tcontent: \"\\f123\";\n}\n.icon-text:before {\n\tcontent: \"\\f124\";\n}\n.icon-sync:before {\n\tcontent: \"\\f125\";\n}\n.icon-sunexp:before {\n\tcontent: \"\\f126\";\n}\n.icon-star:before {\n\tcontent: \"\\f127\";\n}\n.icon-square:before {\n\tcontent: \"\\f128\";\n}\n.icon-sphere:before {\n\tcontent: \"\\f129\";\n}\n.icon-snap_vertex:before {\n\tcontent: \"\\f12a\";\n}\n.icon-snap_perpendicular:before {\n\tcontent: \"\\f12b\";\n}\n.icon-snap_intersection:before {\n\tcontent: \"\\f12c\";\n}\n.icon-snap_edge:before {\n\tcontent: \"\\f12d\";\n}\n.icon-snap_3d:before {\n\tcontent: \"\\f12e\";\n}\n.icon-share:before {\n\tcontent: \"\\f12f\";\n}\n.icon-selectbox:before {\n\tcontent: \"\\f130\";\n}\n.icon-search:before {\n\tcontent: \"\\f131\";\n}\n.icon-screenshot:before {\n\tcontent: \"\\f132\";\n}\n.icon-scale:before {\n\tcontent: \"\\f133\";\n}\n.icon-save:before {\n\tcontent: \"\\f134\";\n}\n.icon-routing:before {\n\tcontent: \"\\f135\";\n}\n.icon-routing-walking:before {\n\tcontent: \"\\f136\";\n}\n.icon-routing-truck:before {\n\tcontent: \"\\f137\";\n}\n.icon-routing-tram:before {\n\tcontent: \"\\f138\";\n}\n.icon-routing-train:before {\n\tcontent: \"\\f139\";\n}\n.icon-routing-ship:before {\n\tcontent: \"\\f13a\";\n}\n.icon-routing-car:before {\n\tcontent: \"\\f13b\";\n}\n.icon-routing-cablecar:before {\n\tcontent: \"\\f13c\";\n}\n.icon-routing-bus:before {\n\tcontent: \"\\f13d\";\n}\n.icon-routing-bicycle:before {\n\tcontent: \"\\f13e\";\n}\n.icon-report:before {\n\tcontent: \"\\f13f\";\n}\n.icon-remove:before {\n\tcontent: \"\\f140\";\n}\n.icon-refresh:before {\n\tcontent: \"\\f141\";\n}\n.icon-rect:before {\n\tcontent: \"\\f142\";\n}\n.icon-rasterexport:before {\n\tcontent: \"\\f143\";\n}\n.icon-radio_unchecked:before {\n\tcontent: \"\\f144\";\n}\n.icon-radio_tristate:before {\n\tcontent: \"\\f145\";\n}\n.icon-radio_checked:before {\n\tcontent: \"\\f146\";\n}\n.icon-pyramid:before {\n\tcontent: \"\\f147\";\n}\n.icon-public:before {\n\tcontent: \"\\f148\";\n}\n.icon-print:before {\n\tcontent: \"\\f149\";\n}\n.icon-polygon:before {\n\tcontent: \"\\f14a\";\n}\n.icon-point:before {\n\tcontent: \"\\f14b\";\n}\n.icon-point_buffer:before {\n\tcontent: \"\\f14c\";\n}\n.icon-plus:before {\n\tcontent: \"\\f14d\";\n}\n.icon-plot_info:before {\n\tcontent: \"\\f14e\";\n}\n.icon-pin:before {\n\tcontent: \"\\f14f\";\n}\n.icon-pick:before {\n\tcontent: \"\\f150\";\n}\n.icon-pick_region:before {\n\tcontent: \"\\f151\";\n}\n.icon-pick_point:before {\n\tcontent: \"\\f152\";\n}\n.icon-person:before {\n\tcontent: \"\\f153\";\n}\n.icon-pen:before {\n\tcontent: \"\\f154\";\n}\n.icon-pdf:before {\n\tcontent: \"\\f155\";\n}\n.icon-paint:before {\n\tcontent: \"\\f156\";\n}\n.icon-open:before {\n\tcontent: \"\\f157\";\n}\n.icon-open_link:before {\n\tcontent: \"\\f158\";\n}\n.icon-ok:before {\n\tcontent: \"\\f159\";\n}\n.icon-oblique:before {\n\tcontent: \"\\f15a\";\n}\n.icon-numericinput:before {\n\tcontent: \"\\f15b\";\n}\n.icon-nodetool:before {\n\tcontent: \"\\f15c\";\n}\n.icon-new:before {\n\tcontent: \"\\f15d\";\n}\n.icon-nav-start:before {\n\tcontent: \"\\f15e\";\n}\n.icon-nav-right:before {\n\tcontent: \"\\f15f\";\n}\n.icon-nav-left:before {\n\tcontent: \"\\f160\";\n}\n.icon-nav-end:before {\n\tcontent: \"\\f161\";\n}\n.icon-move:before {\n\tcontent: \"\\f162\";\n}\n.icon-minus:before {\n\tcontent: \"\\f163\";\n}\n.icon-minus-sign:before {\n\tcontent: \"\\f164\";\n}\n.icon-minimize:before {\n\tcontent: \"\\f165\";\n}\n.icon-middle_v:before {\n\tcontent: \"\\f166\";\n}\n.icon-middle_h:before {\n\tcontent: \"\\f167\";\n}\n.icon-menu-hamburger:before {\n\tcontent: \"\\f168\";\n}\n.icon-measureobj:before {\n\tcontent: \"\\f169\";\n}\n.icon-measure:before {\n\tcontent: \"\\f16a\";\n}\n.icon-measure_polygon:before {\n\tcontent: \"\\f16b\";\n}\n.icon-measure_line:before {\n\tcontent: \"\\f16c\";\n}\n.icon-maximize:before {\n\tcontent: \"\\f16d\";\n}\n.icon-map3d:before {\n\tcontent: \"\\f16e\";\n}\n.icon-logout:before {\n\tcontent: \"\\f16f\";\n}\n.icon-login:before {\n\tcontent: \"\\f170\";\n}\n.icon-lock:before {\n\tcontent: \"\\f171\";\n}\n.icon-list-alt:before {\n\tcontent: \"\\f172\";\n}\n.icon-link:before {\n\tcontent: \"\\f173\";\n}\n.icon-line:before {\n\tcontent: \"\\f174\";\n}\n.icon-line_buffer:before {\n\tcontent: \"\\f175\";\n}\n.icon-light:before {\n\tcontent: \"\\f176\";\n}\n.icon-layers:before {\n\tcontent: \"\\f177\";\n}\n.icon-label:before {\n\tcontent: \"\\f178\";\n}\n.icon-info:before {\n\tcontent: \"\\f179\";\n}\n.icon-info-sign:before {\n\tcontent: \"\\f17a\";\n}\n.icon-import:before {\n\tcontent: \"\\f17b\";\n}\n.icon-identify_region:before {\n\tcontent: \"\\f17c\";\n}\n.icon-identify_radius:before {\n\tcontent: \"\\f17d\";\n}\n.icon-home:before {\n\tcontent: \"\\f17e\";\n}\n.icon-group:before {\n\tcontent: \"\\f17f\";\n}\n.icon-freehand:before {\n\tcontent: \"\\f180\";\n}\n.icon-folder-open:before {\n\tcontent: \"\\f181\";\n}\n.icon-filter:before {\n\tcontent: \"\\f182\";\n}\n.icon-fill:before {\n\tcontent: \"\\f183\";\n}\n.icon-featureform:before {\n\tcontent: \"\\f184\";\n}\n.icon-eye:before {\n\tcontent: \"\\f185\";\n}\n.icon-eye-slash:before {\n\tcontent: \"\\f186\";\n}\n.icon-export:before {\n\tcontent: \"\\f187\";\n}\n.icon-expand:before {\n\tcontent: \"\\f188\";\n}\n.icon-epsilon:before {\n\tcontent: \"\\f189\";\n}\n.icon-embed:before {\n\tcontent: \"\\f18a\";\n}\n.icon-ellipse:before {\n\tcontent: \"\\f18b\";\n}\n.icon-editing:before {\n\tcontent: \"\\f18c\";\n}\n.icon-edited:before {\n\tcontent: \"\\f18d\";\n}\n.icon-editdraw:before {\n\tcontent: \"\\f18e\";\n}\n.icon-draw:before {\n\tcontent: \"\\f18f\";\n}\n.icon-drag:before {\n\tcontent: \"\\f190\";\n}\n.icon-dock:before {\n\tcontent: \"\\f191\";\n}\n.icon-dock_top:before {\n\tcontent: \"\\f192\";\n}\n.icon-dock_right:before {\n\tcontent: \"\\f193\";\n}\n.icon-dock_left:before {\n\tcontent: \"\\f194\";\n}\n.icon-dock_bottom:before {\n\tcontent: \"\\f195\";\n}\n.icon-detach:before {\n\tcontent: \"\\f196\";\n}\n.icon-dataimport:before {\n\tcontent: \"\\f197\";\n}\n.icon-cylinder:before {\n\tcontent: \"\\f198\";\n}\n.icon-cyclomedia:before {\n\tcontent: \"\\f199\";\n}\n.icon-cuboid:before {\n\tcontent: \"\\f19a\";\n}\n.icon-copy:before {\n\tcontent: \"\\f19b\";\n}\n.icon-confirm:before {\n\tcontent: \"\\f19c\";\n}\n.icon-cone:before {\n\tcontent: \"\\f19d\";\n}\n.icon-compare:before {\n\tcontent: \"\\f19e\";\n}\n.icon-collapse:before {\n\tcontent: \"\\f19f\";\n}\n.icon-cog:before {\n\tcontent: \"\\f1a0\";\n}\n.icon-clone:before {\n\tcontent: \"\\f1a1\";\n}\n.icon-clock:before {\n\tcontent: \"\\f1a2\";\n}\n.icon-clear:before {\n\tcontent: \"\\f1a3\";\n}\n.icon-circle:before {\n\tcontent: \"\\f1a4\";\n}\n.icon-circle_full:before {\n\tcontent: \"\\f1a5\";\n}\n.icon-chevron-up:before {\n\tcontent: \"\\f1a6\";\n}\n.icon-chevron-right:before {\n\tcontent: \"\\f1a7\";\n}\n.icon-chevron-left:before {\n\tcontent: \"\\f1a8\";\n}\n.icon-chevron-down:before {\n\tcontent: \"\\f1a9\";\n}\n.icon-checked:before {\n\tcontent: \"\\f1aa\";\n}\n.icon-catalog:before {\n\tcontent: \"\\f1ab\";\n}\n.icon-camera:before {\n\tcontent: \"\\f1ac\";\n}\n.icon-buffer:before {\n\tcontent: \"\\f1ad\";\n}\n.icon-box:before {\n\tcontent: \"\\f1ae\";\n}\n.icon-bookmark:before {\n\tcontent: \"\\f1af\";\n}\n.icon-bglayer:before {\n\tcontent: \"\\f1b0\";\n}\n.icon-below:before {\n\tcontent: \"\\f1b1\";\n}\n.icon-before:before {\n\tcontent: \"\\f1b2\";\n}\n.icon-arrow-up:before {\n\tcontent: \"\\f1b3\";\n}\n.icon-arrow-down:before {\n\tcontent: \"\\f1b4\";\n}\n.icon-after:before {\n\tcontent: \"\\f1b5\";\n}\n.icon-above:before {\n\tcontent: \"\\f1b6\";\n}\n.icon-above_zero:before {\n\tcontent: \"\\f1b7\";\n}\n.icon-above_terr:before {\n\tcontent: \"\\f1b8\";\n}\n.icon-3d2d:before {\n\tcontent: \"\\f1b9\";\n}\n.icon-3d:before {\n\tcontent: \"\\f1ba\";\n}\n.icon-2d:before {\n\tcontent: \"\\f1bb\";\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
